var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlaybackPlay = function SvgPlaybackPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.95,
    d: "M6 16.507V7.493c0-1.318 0-1.976.277-2.366a1.5 1.5 0 0 1 1.03-.619c.474-.062 1.056.247 2.219.865l8.484 4.508c1.295.687 1.942 1.031 2.154 1.49.185.399.185.86 0 1.258-.212.459-.859.803-2.154 1.49l-8.484 4.508c-1.163.618-1.745.927-2.22.865a1.5 1.5 0 0 1-1.029-.619C6 18.483 6 17.825 6 16.507Z"
  })));
};
export default SvgPlaybackPlay;